"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestFeedbackType = void 0;
var TestFeedbackType;
(function (TestFeedbackType) {
    TestFeedbackType["validation"] = "validation";
    TestFeedbackType["info"] = "info";
})(TestFeedbackType || (exports.TestFeedbackType = TestFeedbackType = {}));
